import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

import "./sponsors.scss";
// core components

function SignUp() {
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [lastFocus, setLastFocus] = React.useState(false);
  const [emailFocus, setEmailFocus] = React.useState(false);

  let date = moment("02/18/2025").tz("Asia/Singapore");

  const [count, setCount] = useState({
    days: 0,
    hours: "00",
    minutes: "00",
    seconds: "00",
    timeUp: false,
  });

  useEffect(() => {
    setInterval(() => {
      let currentDate = moment().tz("Asia/Singapore");
      let difference = date - currentDate;

      if (difference < 1) {
        setCount({ timeUp: true });
      } else {
        let days = Math.floor(difference / (1000 * 60 * 60 * 24));
        let hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((difference / (1000 * 60)) % 60);
        // let seconds = Math.floor((difference / (1000)) % 60);
        setCount({
          hours: hours > 9 ? hours : `0${hours}`,
          minutes: minutes > 9 ? minutes : `0${minutes}`,
          // seconds: seconds > 9 ? seconds : `0${seconds}`,
          days,
        });
      }
    }, 1000);
  }, []);

  const { days, hours, minutes, timeUp } = count;
  const dayString = days > 1 ? "days" : "day";

  return (
    <>
      <div
        className="mt-4 pb-5"
        style={{
          backgroundImage: "url(" + require("assets/img/bg11.jpg") + ")",
          // backgroundSize: "cover",
          backgroundPosition: "top center",
          // minHeight: "700px",
          minHeight: "350px",
        }}
      >
        <Container>
          <div className="row">
            <div className="col-lg-2 offset-lg-1 col-md-6" align="center">
              <div className="inclusive">
                <p>
                  {/* <img
                    alt="..."
                    src={require("assets/img/icons/anywhere.png")}
                    className="icons-scheduler  img-responsive"
                  ></img> */}
                  <i
                    style={{ fontSize: "65px" }}
                    aria-hidden={true}
                    className="icons-scheduler text-white now-ui-icons tech_laptop"
                  ></i>
                </p>
                <p>Access your itinerary anywhere</p>
              </div>
            </div>
            <div className="col-lg-2 col-md-6" align="center">
              <div className="inclusive">
                <p>
                  {" "}
                  <img
                    alt="..."
                    src={require("assets/img/icons/filter.png")}
                    className="icons-scheduler  img-responsive"
                  ></img>
                </p>
                <p>Filter preferred countries and specialization</p>
              </div>
            </div>
            <div className="col-lg-2 col-md-6" align="center">
              <div className="inclusive">
                <p>
                  <img
                    alt="..."
                    src={require("assets/img/icons/time.png")}
                    className="icons-scheduler  img-responsive"
                  ></img>
                </p>
                <p>Time saving and efficient</p>
              </div>
            </div>
            <div className="col-lg-2 col-md-6" align="center">
              <div className="inclusive">
                <p>
                  <img
                    alt="..."
                    src={require("assets/img/icons/schedule.png")}
                    className="icons-scheduler  img-responsive"
                  ></img>
                </p>
                <p>Pre-schedule meetings with all delegates</p>
              </div>
            </div>
            <div className="col-lg-2 col-md-6" align="center">
              <div className="inclusive">
                <p>
                  <img
                    alt="..."
                    src={require("assets/img/icons/partner.png")}
                    className="icons-scheduler img-responsive"
                  ></img>
                </p>
                <p>Arrange meetings with the right partners!</p>
              </div>
            </div>
          </div>

          <Container className="my-5 sponsors-container bg-white shadow">
            <Row className="justify-content-center">
              <h1 className="font-weight-bold">Sponsors</h1>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col
                xs="12"
                md="3"
                className="d-flex justify-content-center mb-3 mb-md-0"
              >
                <a href="https://schneider-transport.com/en/" target="_blank">
                  <img
                    src={require("assets/img/Macau-2026/sponsors/schneider.png")}
                    alt="schneider"
                    className="sponsor-logo large mb-3"
                  />
                </a>
              </Col>
              <Col xs="12" md="3" className="d-flex justify-content-center">
                <a href="https://www.logi-sys.com/" target="_blank">
                  <img
                    src={require("assets/img/Macau-2026/sponsors/Logi-Sys-new.png")}
                    alt="Logi-Sys"
                    className="sponsor-logo large"
                  />
                </a>
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center mb-4">
              <h4 className="mt-4 font-weight-bold">Starlight Sponsor</h4>
            </Row>

            <Row className="align-items-center justify-content-center">
              <Col
                xs="12"
                md="3"
                className="d-flex justify-content-center mb-3 mb-md-0"
              >
                <a href="https://quotiss.com/" target="_blank">
                  <img
                    src={require("assets/img/Macau-2026/sponsors/QUOTISS.png")}
                    alt="quotiss"
                    className="sponsor-logo medium mb-3"
                  />
                </a>
              </Col>
              <Col xs="12" md="3" className="d-flex justify-content-center">
                <a href="https://pfc24.pl/en/" target="_blank">
                  <img
                    src={require("assets/img/Macau-2026/sponsors/PFC.jpg")}
                    alt="Polish Forwarding Company"
                    className="sponsor-logo medium"
                  />
                </a>
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center mb-4">
              <h5 className="mt-4 font-weight-bold">Gold Sponsor</h5>
            </Row>

            {/* Row 3 - Happy Hour, Grand Prix, Half-Page Advertisement */}
            <Row className="justify-content-center mb-4">
              {/* <Col md="3" className="text-center">
                <img
                  src="/images/happyhour.png"
                  alt="Happy Hour Sponsor"
                  className="sponsor-logo small"
                />
                <p className="mt-2">Happy Hour Sponsor</p>
              </Col> */}

              <Col md="3" className="text-center">
                <a href="https://www.agilebeyond.net/" target="_blank">
                  <img
                    src={require("assets/img/Macau-2026/sponsors/AgileBeyondLogo.png")}
                    alt="AgileBeyond"
                    className="sponsor-logo small mb-3"
                  />
                </a>
                <p className="mt-2 font-weight-bold">Grand Prix</p>
              </Col>
              <Col md="3" className="text-center">
                <a href="https://2hgroup.com.tr/" target="_blank">
                  <img
                    src={require("assets/img/Macau-2026/sponsors/2H-coffee-break.jpg")}
                    alt="2H GROUP LOGISTICS"
                    className="sponsor-logo medium"
                  />
                </a>
                <p className="mt-2 font-weight-bold">Coffee Break Sponsor</p>
              </Col>

              {/* 
              <Col md="3" className="text-center">
                <img
                  src="/images/halfpage.png"
                  alt="Half Page Ad"
                  className="sponsor-logo small"
                />
                <p className="mt-2">Half-Page Advertisement</p>
              </Col> */}
            </Row>

            {/* Row 4 - Coffee Break, F&B Sponsor */}
            {/* <Row className="justify-content-center mb-4">
              <Col md="4" className="text-center">
                <img
                  src="/images/coffeebreak.png"
                  alt="Coffee Break Sponsor"
                  className="sponsor-logo medium"
                />
                <p className="mt-2">Coffee Break Sponsor</p>
              </Col>

              <Col md="4" className="text-center">
                <img
                  src="/images/fnb.png"
                  alt="F&B Sponsor"
                  className="sponsor-logo medium"
                />
                <p className="mt-2">F&B Sponsor</p>
              </Col>
            </Row> */}
          </Container>
          {/*<Container className="text-center mt-5 pb-5">
            <Row className="justify-content-md-center">
              <Col lg="8" md="12">
                <h2 className="font-weight-bold meeting-launch-title">
                  Launch of Meeting Scheduler{" "}
                </h2>

                {timeUp ? (
                  <p className="description">Event in progress</p>
                ) : (
                  <div className="">
                    <div className="container">
                      <div className="d-flex flex-row justify-content-center">
                        <div className="d-flex flex-column mx-3 py-3 px-3 border text-black bg-white shadow">
                          <h2 className="mb-1">{`${days}`}</h2>
                          <span>{`${dayString}`}</span>
                        </div>
                        <div className="d-flex flex-column mx-3 py-3 px-3 border text-black bg-white shadow">
                          <h2 className="mb-1">{`${hours}`}</h2>
                          <span>hours</span>
                        </div>
                        <div className="d-flex flex-column mx-3 py-3 px-3 border text-black bg-white shadow">
                          <h2 className="mb-1">{`${minutes}`}</h2>
                          <span>minutes</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )} 
              </Col>
            </Row>
          </Container>*/}

          {/* <Container className="bg-white shadow mt-4 pb-5" id=""> ---> SPONSOR CONTAINER <-----
            <Row className="justify-content-center mt-5">
              <h1 className="font-weight-bold pt-5">Sponsors</h1>
            </Row>
            <Row className="mx-3 mt-5 d-flex flex-lg-column row justify-content-center">
              <div className="text-center platinum">
                      <h3 className="font-weight-bold">Platinum </h3>
                      <div className="d-md-flex justify-content-center" style={{gap: '30px 50px'}}>
                        <a target="_blank" href="https://softlinkglobal.com/">
                          <img
                              alt="Logi-Sys"
                              src={require("assets/img/sponsor/Logi-Sys-new.png")}
                              className="img-responsive"
                              width={350}
                            ></img>
                        </a>
                      </div>
                  </div>
              <div className="text-center gold">
                <h3 className="font-weight-bold">Gold</h3>
                <div
                  className="d-md-flex justify-content-center"
                  style={{ gap: "30px 50px" }}
                >
                  <a target="_blank"
                    href="https://www.googleadservices.com/pagead/aclk?sa=L&ai=DChcSEwi_997t0pL_AhWEV30KHRs5AqoYABACGgJzZg&ohost=www.google.com&cid=CAESbOD2Hyfi7x_e0IKM2yHEBGWSIx3Y7PeuizF0BqzavZ8fn-5YmOS0P6ZD44cpI1C0O9yd44EvxgElTe4hMWvHhHoY1GYPbsSvkwlZr80WcekkKuN4NAp-B5Uk4ddQXC-vznVPzswJw_Fw_nQ-XQ&sig=AOD64_09RxJznt32p7tWiMXA79ESOjiKlg&q&adurl&ved=2ahUKEwizytft0pL_AhXCwjgGHQ9-C2gQ0Qx6BAgKEAE"
                  >
                    <img
                      alt="QUOTISS"
                      src={require("assets/img/sponsor/QUOTISS.png")}
                      className="img-responsive"
                      width={250}
                    ></img>
                  </a>
                  <a target="_blank" href="https://www.atlogistics.co">
                        <img
                              alt="nsr"
                              src={require("assets/img/sponsor/AT-international.png")}
                              className="img-responsive"
                              width={250}
                            ></img>
                        </a>
                  <a target="_blank" href="#">
                    <img
                      alt="GOL logo"
                      src={require("assets/img/sponsor/GOL.png")}
                      className="img-responsive"
                      width={250}
                    ></img>
                  </a>
                </div>
              </div>
            </Row>
            <Row className="justify-content-center mb-5">
            <div className="text-center mt-5 px-3">
                <h3 className="font-weight-bold">Golf</h3>
                <div className="d-flex justify-content-center">
                  <a target="_blank" href="https://agilebeyond.net/">
                    <img
                      alt="Agile Beyond"
                      src={require("assets/img/sponsor/AgileBeyondLogo.png")}
                      className="img-responsive"
                      width={250}
                    ></img>
                  </a>
                </div>
              </div>
              <div className="text-center mt-5 px-3">
                <h3 className="font-weight-bold">Happy Hour</h3>
                <div className="d-flex justify-content-center">
                  <a target="_blank" href="https://www.shipco.com/">
                    <img
                      alt="ShipcoTransportLogo"
                      src={require("assets/img/sponsor/ShipcoTransportLogo.png")}
                      className="img-responsive"
                      width={150}
                    ></img>
                  </a>
                </div>
              </div>
              <div className="text-center mt-5">
                <h3 className="font-weight-bold">Coffee Break</h3>
                <div className="d-flex justify-content-center">
                  <a target="_blank" href="https://stlojistik.com.tr/en/">
                    <img
                      alt="ST GLOBAL FORWARDING & LOGISTIC SERVICES CO."
                      src={require("assets/img/sponsor/st.png")}
                      className="img-responsive"
                      width={200}
                    ></img>
                  </a>
                  <a target="_blank" href="http://www.whalelogistics.com/">
                    <img
                      alt="Whales Logistics Co. Ltd."
                      src={require("assets/img/sponsor/whale_logistics.png")}
                      className="img-responsive"
                      width={200}
                    ></img>
                  </a>
                </div>
              </div>
            </Row>
          </Container> */}

          {/* <Card className="card-signup" data-background-color="blue">
              <Form action="" className="form" method="">
                <CardHeader className="text-center">
                  <CardTitle className="title-up" tag="h3">
                    Inquire
                  </CardTitle>
                  <div className="social-line">
                    <Button
                      className="btn-neutral btn-icon btn-round"
                      color="facebook"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-facebook-square"></i>
                    </Button>
                    <Button
                      className="btn-neutral btn-icon btn-round"
                      color="twitter"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="lg"
                    >
                      <i className="fab fa-twitter"></i>
                    </Button>
                    <Button
                      className="btn-neutral btn-icon btn-round"
                      color="google"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-google-plus"></i>
                    </Button>
                  </div>
                </CardHeader>
                <CardBody>
                  <InputGroup
                    className={
                      "no-border" + (firstFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons users_circle-08"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="First Name..."
                      type="text"
                      onFocus={() => setFirstFocus(true)}
                      onBlur={() => setFirstFocus(false)}
                    ></Input>
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (lastFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons text_caps-small"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Last Name..."
                      type="text"
                      onFocus={() => setLastFocus(true)}
                      onBlur={() => setLastFocus(false)}
                    ></Input>
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (emailFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_email-85"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email..."
                      type="text"
                      onFocus={() => setEmailFocus(true)}
                      onBlur={() => setEmailFocus(false)}
                    ></Input>
                  </InputGroup>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-neutral btn-round"
                    color="info"
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                    size="lg"
                  >
                    Get Started
                  </Button>
                </CardFooter>
              </Form>
            </Card> */}
          {/* <div className="col text-center">
            <Button
              className="btn-round btn-white"
              color="default"
              to="/login-page"
              outline
              size="lg"
              tag={Link}
            >
              View Login Page
            </Button>
          </div> */}
        </Container>
      </div>
    </>
  );
}

export default SignUp;
